import React from 'react';
import Icon from '../../../components/AppIcon';

const MaterialDetails = () => {
  const materialInfo = [
    {
      category: 'Tecidos Premium',
      description: 'Selecionados para durabilidade, conforto e elegância.',
      features: ['Alta durabilidade', 'Fácil manutenção', 'Cores vibrantes'],
      icon: 'Sparkles'
    },
    {
      category: 'Tecidos Básicos',
      description: 'Versáteis e com excelente custo-benefício.',
      features: ['Versatilidade', 'Custo-benefício', 'Fácil limpeza'],
      icon: 'Package'
    },
    {
      category: 'Cordas Naturais',
      description: '100% naturais com toque rústico e autêntico.',
      features: ['100% natural', 'Resistente', 'Textura única'],
      icon: 'TreePine'
    },
    {
      category: 'Fibras Especiais',
      description: 'Texturas especiais e acabamentos únicos.',
      features: ['Sustentável', 'Resistente à umidade', 'Acabamento único'],
      icon: 'Leaf'
    },
    {
      category: 'Madeiras Nobres',
      description: 'Madeiras brasileiras certificadas e sustentáveis.',
      features: ['Madeira certificada', 'Alta durabilidade', 'Beleza natural'],
      icon: 'TreePine'
    }
  ];

  return (
    <section className="py-16 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-playfair text-3xl md:text-4xl font-bold text-foreground mb-4">
            Sobre Nossos Materiais
          </h2>
          <p className="text-text-secondary text-lg max-w-3xl mx-auto">
            Materiais selecionados para garantir qualidade e sustentabilidade.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6">
          {materialInfo.map((material, index) => (
            <div 
              key={index} 
              className="group bg-card border border-border rounded-xl p-5 hover:shadow-premium hover:border-primary/30 transition-all duration-300 w-full md:w-[calc(50%-12px)] lg:w-[calc(33.333%-16px)] max-w-sm"
            >
              <div className="flex items-start space-x-3 mb-3">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center flex-shrink-0 group-hover:bg-primary/20 transition-colors duration-300">
                  <Icon name={material.icon} size={20} color="var(--color-primary)" />
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="font-playfair text-lg font-bold text-foreground mb-1">
                    {material.category}
                  </h3>
                  <p className="text-text-secondary text-sm leading-relaxed">
                    {material.description}
                  </p>
                </div>
              </div>
              
              <ul className="space-y-1.5 mt-4">
                {material.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-xs text-text-secondary">
                    <Icon name="Check" size={14} color="var(--color-primary)" className="mr-2 flex-shrink-0" />
                    <span>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MaterialDetails;

